import { helper } from '@/utils'
import Logo from '../Logo/Logo.vue'
import Company from '../Company/Company.vue'

const messages = {
  en: {
    message: {
      title: 'Set New Password',
      subtitle: 'To reset your password, enter a new password below.',
      pw_new1: 'NEW PASSWORD',
      pw_new1_ph: 'Enter your new password',
      pw_new2: 'RETYPE NEW PASSWORD',
      pw_new2_ph: 'Retype your new password',
      length_warn: 'Password too short or too long.',
      length_desc: 'Passwords must be between 8-20 characters.',
      not_match: 'Passwords not matching.',
      not_match_desc: 'Make sure your new passwords match.',
      server_error: 'Server error.',
      server_error_desc: 'Please try again later.',
      reset_button: 'Reset Password',
      link_expired: 'Your link expires after 24 hours or once a new password is set. If you still wish to reset your password, please use the mobile app to request a new password reset link.',
      reset_done: 'Please reopen the {{app_name}} app and try logging into your account.',
      title_done: 'Password Changed',
      title_expired: 'This password reset link is no longer available'
    }
  },
  zh: {
    message: {
      title: '重設密碼',
      subtitle: '請在下方輸入新的密碼',
      pw_new1: '新密碼',
      pw_new1_ph: '輸入新密碼',
      pw_new2: '確認新密碼',
      pw_new2_ph: '再次輸入您的新密碼',
      length_warn: '密碼太短或太長',
      length_desc: '密碼長度必須介於8-20個字元',
      not_match: '密碼不相同.',
      not_match_desc: '請檢查輸入的新密碼.',
      server_error: '伺服器發生錯誤.',
      server_error_desc: '請稍候再嘗試一次',
      reset_button: '重設密碼',
      link_expired: '此連結已過期或者已經使用過。如果您想要再次設定新密碼，請使用手機 app 再次發出重設密碼的請求。',
      reset_done: '請開啟 {{app_name}} 重新登入您的帳號',
      title_done: '密碼已重設',
      title_expired: '此連結已過期'
    }
  }
}

export default {
  name: 'Reset',
  components: { Company, Logo },
  created () {
    this.getLang()
  },
  data () {
    return {
      component: 'reset',
      footer: {},
      primaryColor: '#00BAFF',
      appName: '',
      pw_new1: '',
      pw_new2: '',
      reset_error1: false,
      reset_error2: false,
      reset_error3: false,
      state: 'reset',
      title: 'Set New Password',
      translate: '',
      code: this.$route.params.code,
      lang: this.$route.params.lang || ''
    }
  },
  methods: {
    getData () {
      return this.getTheme()
        .then(theme => {
          this.footer = {
            companyAddress: theme.company_address,
            companyContact: theme.company_contact,
            companyName: theme.company_name,
            companyUrl: theme.company_url
          }
          this.primaryColor = theme.primary_color
          this.appName = theme.app_name
        })
        .catch((error) => helper.showErrorMessage(this, this.component, error))
    },
    getTheme () {
      return this.$api.getTheme()
        .then(({ body }) => body)
    },
    getLang () {
      if (this.lang === 'zh-TW') {
        this.translate = messages.zh.message
      } else {
        this.translate = messages.en.message
      }
    },
    updateAppName (sentence) {
      return sentence.replace('{{app_name}}', this.appName)
    },
    submit () {
      this.reset_error1 = false
      this.reset_error2 = false
      this.reset_error3 = false

      if (this.pw_new1.length < 8 || this.pw_new1.length > 20) {
        this.reset_error1 = true
        return false
      }
      if (this.pw_new1 !== this.pw_new2) {
        this.reset_error2 = true
        return false
      }
      this.$api.updatePassword(this.code, this.pw_new1)
        .then((data) => {
          this.state = 'done'
          this.title = this.translate.title_done
          console.log('***code', this.code, this.title)
        })
        .catch((error) => {
          if (error.status === 400) {
            this.state = 'expired'
            this.title = this.translate.title_expired
          } else {
            this.reset_error3 = true
          }
        })
    }
  },
  mounted () {
    this.getData()
  }
}



// WEBPACK FOOTER //
// ./src/assets/pages/Reset/Reset.js